import { reactive, computed } from 'vue';

/**
 * 会话状态。
 *
 * 没上 Pinia —— 整个应用需要共享的只有 token 和医生信息两样东西，
 * 一个 reactive 对象足够，少一层抽象少一层要读的代码。
 */

const TOKEN_KEY = 'hz_token';
/** 同一个服务号进来两种人：医生和业务员，token 长得一样，落地页不一样 */
const KIND_KEY = 'hz_kind';

export interface DoctorProfile {
  id: number;
  nickname: string | null;
  avatarUrl: string | null;
  realName: string | null;
  phone: string | null;
  gender: 'male' | 'female' | null;
  birthday: string | null;
  workYears: number | null;
  email: string | null;
  clinicNameInput: string | null;
  status: string;
}

export interface PointsSummary {
  balance: number;
  totalEarned: number;
  totalSpent: number;
}

const state = reactive({
  token: readToken(),
  kind: readKind(),
  doctor: null as DoctorProfile | null,
  points: { balance: 0, totalEarned: 0, totalSpent: 0 } as PointsSummary,
  ready: false,
});

export type SessionKind = 'doctor' | 'sales';

function readKind(): SessionKind | null {
  try {
    const v = localStorage.getItem(KIND_KEY);
    return v === 'sales' ? 'sales' : v === 'doctor' ? 'doctor' : null;
  } catch {
    return null;
  }
}

function readToken(): string {
  try {
    return localStorage.getItem(TOKEN_KEY) || '';
  } catch {
    // 隐私模式下 localStorage 会抛异常，降级为仅本次会话有效
    return '';
  }
}

export function setToken(token: string, kind: SessionKind = 'doctor'): void {
  state.token = token;
  state.kind = kind;
  try {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(KIND_KEY, kind);
  } catch {
    /* 存不下就算了，内存里那份仍然可用 */
  }
}

export function clearSession(): void {
  state.token = '';
  state.kind = null;
  state.doctor = null;
  state.points = { balance: 0, totalEarned: 0, totalSpent: 0 };
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(KIND_KEY);
  } catch {
    /* 同上 */
  }
}

export const session = state;
export const isLoggedIn = computed(() => Boolean(state.token));
export { TOKEN_KEY };
